import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hod-identified-calendar',
  templateUrl: './hod-identified-calendar.component.html',
  styleUrls: ['./hod-identified-calendar.component.scss'],
})
export class HodIdentifiedCalendarComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

  // Dummy Data for Table
  trainingPrograms = [
    {
      hodName: 'Narayan',
      department: 'IT',
      code: 'IT001',
      title: 'Problem Solving',
      startDate: '1-10-24',
      endDate: '15-10-24',
      programDetails: 'abc....',
      brochure: '',
      status: 'Pending',
      comment: 'sales team',
    },
    {
      hodName: 'Tim',
      department: 'R&D',
      code: 'R&D001',
      title: 'Excel',
      startDate: '3-10-24',
      endDate: '23-10-24',
      programDetails: 'abc....',
      brochure: '',
      status: 'Pending',
      comment: 'accounts team',
    },
  ];

  // Define headers dynamically
  tableHeaders = [
    { label: 'HOD name', key: 'hodName' },
    { label: 'HOD dept.', key: 'department' },
    { label: 'HOD Code', key: 'code' },
    { label: 'Programme Title', key: 'title' },
    { label: 'Start Date', key: 'startDate' },
    { label: 'End Date', key: 'endDate' },
    { label: 'Programme Details', key: 'programDetails' },
    { label: 'Upload programme brochure', key: 'brochure' },
  ];

  // Approve Program
  approveProgram(program: any) {
    program.status = 'Approved';
  }

  // Reject Program
  rejectProgram(program: any) {
    program.status = 'Rejected';
  }

}
